var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 466,
    viewBox: "0 0 1440 466",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M0 465.5V124.5C126 58 222.5 12.5 358.5 12.5C586.5 12.5 761 171.439 1028 170C1295 168.561 1440 0 1440 0V465.5H0Z",
    fill: "url(#paint0_linear_1711_385)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M0 465.5V188.5C70.5 262 196 335.5 332 335.5C560 335.5 804 40.5 1021.5 40.5C1239 40.5 1302.5 166.5 1440 166.5V465.5H0Z",
    fill: "url(#paint1_linear_1711_385)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1711_385",
    x1: 638,
    y1: 77.5,
    x2: 766.307,
    y2: 616.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9CDD9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1711_385",
    x1: 638,
    y1: 41,
    x2: 733.667,
    y2: 443.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/Waves.12ec178c261a8660c3066f17d8a68be8.svg";
export { ForwardRef as ReactComponent };